import 'slick-carousel';

$('.slider-hero').each(function() {
  $(this)
    .find('.slider__slides')
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: true,
      prevArrow: $(this).find('.slider__nav-prev'),
      nextArrow: $(this).find('.slider__nav-next'),
      appendDots: $(this).find('.slider__nav'),
    });
});
